<template>
  <router-link v-bind="{ ...$attrs, ...$props }" :to="modifiedTo">
    <slot></slot>
  </router-link>
</template>

<script>

import addForecastToLinksQueryStringMixin from '@/mixins/addForecastToLinksQueryString.js';

export default {
  mixins: [addForecastToLinksQueryStringMixin],
  props: {
    to: {
      type: Object,
      default: () => ({}),
    },
  },
};

</script>
